import { render, staticRenderFns } from "./zixun1.vue?vue&type=template&id=3f7576f2&scoped=true&"
import script from "./zixun1.vue?vue&type=script&lang=js&"
export * from "./zixun1.vue?vue&type=script&lang=js&"
import style0 from "./zixun1.vue?vue&type=style&index=0&id=3f7576f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7576f2",
  null
  
)

export default component.exports